import React from 'react';
import { NewMenuItem, NewMenuItemProps } from './NewMenuItem';
import { Menu as MenuStyles, StyledNav } from './styles';
import { NewSubMenuItem } from './NewSubMenuItem';
import { AccordionMenuItem } from './AccordionMenuItem';
import { fixItems } from './FixItems';

export interface MenuProps {
  menuItems?: NewMenuItemProps[];
  isSidebarOpen?: boolean;
  isTeiaHeader?: boolean;
  onItemClick?: (menuItem: NewMenuItemProps) => void;
}

export const NewZingMenu = ({ menuItems, isSidebarOpen = true, isTeiaHeader = false, onItemClick, ...props }: MenuProps) => {
  const items = fixItems(menuItems);
  
  return (
    <StyledNav {...props}>
      <MenuStyles>
        {items?.map((menuItem, index) => {
          if (menuItem.isAccordion === true && menuItem.icon) {
            return (
              <AccordionMenuItem
                key={index}
                title={menuItem.title}
                icon={menuItem.icon}
                subItems={menuItem.subItems ?? []}
                active={menuItem.active}
                isSidebarOpen={isSidebarOpen}
                isTeiaHeader={isTeiaHeader}
              />
            );
          }

          if (menuItem.isSubMenu === true) {
            return (
              <NewSubMenuItem
                {...menuItem}
                isSidebarOpen={isSidebarOpen}
                isTeiaHeader={isTeiaHeader}
                key={index}
              />
            );
          }

          return (
            <NewMenuItem
              {...menuItem}
              onClick={() => onItemClick?.(menuItem)}
              isSidebarOpen={isSidebarOpen}
              isTeiaHeader={isTeiaHeader}
              key={index}
            />
          );
        })}
      </MenuStyles>
    </StyledNav>
  );
};
